import type { ColorKey, SizeKey } from '@/types/tailwind'

export const bgColor500 = {
  black: 'bg-black',
  white: 'bg-white',
  slate: 'bg-slate-500',
  gray: 'bg-gray-500',
  zinc: 'bg-zinc-500',
  neutral: 'bg-neutral-500',
  stone: 'bg-stone-500',
  red: 'bg-red-500',
  orange: 'bg-orange-500',
  amber: 'bg-amber-500',
  yellow: 'bg-yellow-500',
  lime: 'bg-lime-500',
  green: 'bg-green-500',
  emerald: 'bg-emerald-500',
  teal: 'bg-teal-500',
  cyan: 'bg-cyan-500',
  sky: 'bg-sky-500',
  blue: 'bg-blue-500',
  indigo: 'bg-indigo-500',
  violet: 'bg-violet-500',
  purple: 'bg-purple-500',
  fuchsia: 'bg-fuchsia-500',
  pink: 'bg-pink-500',
  rose: 'bg-rose-500',
  default: '',
} as const

export const bgColor500p25: Record<ColorKey, string> = {
  black: 'bg-black/25',
  white: 'bg-white/25',
  slate: 'bg-slate-500/25',
  gray: 'bg-gray-500/25',
  zinc: 'bg-zinc-500/25',
  neutral: 'bg-neutral-500/25',
  stone: 'bg-stone-500/25',
  red: 'bg-red-500/25',
  orange: 'bg-orange-500/25',
  amber: 'bg-amber-500/25',
  yellow: 'bg-yellow-500/25',
  lime: 'bg-lime-500/25',
  green: 'bg-green-500/25',
  emerald: 'bg-emerald-500/25',
  teal: 'bg-teal-500/25',
  cyan: 'bg-cyan-500/25',
  sky: 'bg-sky-500/25',
  blue: 'bg-blue-500/25',
  indigo: 'bg-indigo-500/25',
  violet: 'bg-violet-500/25',
  purple: 'bg-purple-500/25',
  fuchsia: 'bg-fuchsia-500/25',
  pink: 'bg-pink-500/25',
  rose: 'bg-rose-500/25',
  default: 'bg-default-500/25',
  // warmGray: 'bg-warmGray-500/25',
  // trueGray: 'bg-trueGray-500/25',
  // coolGray: 'bg-coolGray-500/25',
  // blueGray: 'bg-blueGray-500/25',
}

export const bgColor600p25: Record<ColorKey, string> = {
  black: 'bg-black/25',
  white: 'bg-white/25',
  slate: 'bg-slate-600/25',
  gray: 'bg-gray-600/25',
  zinc: 'bg-zinc-600/25',
  neutral: 'bg-neutral-600/25',
  stone: 'bg-stone-600/25',
  red: 'bg-red-600/25',
  orange: 'bg-orange-600/25',
  amber: 'bg-amber-600/25',
  yellow: 'bg-yellow-600/25',
  lime: 'bg-lime-600/25',
  green: 'bg-green-600/25',
  emerald: 'bg-emerald-600/25',
  teal: 'bg-teal-600/25',
  cyan: 'bg-cyan-600/25',
  sky: 'bg-sky-600/25',
  blue: 'bg-blue-600/25',
  indigo: 'bg-indigo-600/25',
  violet: 'bg-violet-600/25',
  purple: 'bg-purple-600/25',
  fuchsia: 'bg-fuchsia-600/25',
  pink: 'bg-pink-600/25',
  rose: 'bg-rose-600/25',
  default: 'bg-default-600/25',
  // warmGray: 'bg-warmGray-600/25',
  // trueGray: 'bg-trueGray-600/25',
  // coolGray: 'bg-coolGray-600/25',
  // blueGray: 'bg-blueGray-600/25',
}
export const borderColor500: Record<ColorKey, string> = {
  black: 'border-black',
  white: 'border-white',
  slate: 'border-slate-500',
  gray: 'border-gray-500',
  zinc: 'border-zinc-500',
  neutral: 'border-neutral-500',
  stone: 'border-stone-500',
  red: 'border-red-500',
  orange: 'border-orange-500',
  amber: 'border-amber-500',
  yellow: 'border-yellow-500',
  lime: 'border-lime-500',
  green: 'border-green-500',
  emerald: 'border-emerald-500',
  teal: 'border-teal-500',
  cyan: 'border-cyan-500',
  sky: 'border-sky-500',
  blue: 'border-blue-500',
  indigo: 'border-indigo-500',
  violet: 'border-violet-500',
  purple: 'border-purple-500',
  fuchsia: 'border-fuchsia-500',
  pink: 'border-pink-500',
  rose: 'border-rose-500',
  default: 'border-default-500',
  // warmGray: 'border-warmGray-500',
  // trueGray: 'border-trueGray-500',
  // coolGray: 'border-coolGray-500',
  // blueGray: 'border-blueGray-500',
}
export const borderColor600: Record<ColorKey, string> = {
  black: 'border-black',
  white: 'border-white',
  slate: 'border-slate-600',
  gray: 'border-gray-600',
  zinc: 'border-zinc-600',
  neutral: 'border-neutral-600',
  stone: 'border-stone-600',
  red: 'border-red-600',
  orange: 'border-orange-600',
  amber: 'border-amber-600',
  yellow: 'border-yellow-600',
  lime: 'border-lime-600',
  green: 'border-green-600',
  emerald: 'border-emerald-600',
  teal: 'border-teal-600',
  cyan: 'border-cyan-600',
  sky: 'border-sky-600',
  blue: 'border-blue-600',
  indigo: 'border-indigo-600',
  violet: 'border-violet-600',
  purple: 'border-purple-600',
  fuchsia: 'border-fuchsia-600',
  pink: 'border-pink-600',
  rose: 'border-rose-600',
  default: 'border-default-600',
  // warmGray: 'border-warmGray-600',
  // trueGray: 'border-trueGray-600',
  // coolGray: 'border-coolGray-600',
  // blueGray: 'border-blueGray-600',
}

export const outlineColor500p25: Record<ColorKey, string> = {
  black: 'outline-black/25',
  white: 'outline-white/25',
  slate: 'outline-slate-500/25',
  gray: 'outline-gray-500/25',
  zinc: 'outline-zinc-500/25',
  neutral: 'outline-neutral-500/25',
  stone: 'outline-stone-500/25',
  red: 'outline-red-500/25',
  orange: 'outline-orange-500/25',
  amber: 'outline-amber-500/25',
  yellow: 'outline-yellow-500/25',
  lime: 'outline-lime-500/25',
  green: 'outline-green-500/25',
  emerald: 'outline-emerald-500/25',
  teal: 'outline-teal-500/25',
  cyan: 'outline-cyan-500/25',
  sky: 'outline-sky-500/25',
  blue: 'outline-blue-500/25',
  indigo: 'outline-indigo-500/25',
  violet: 'outline-violet-500/25',
  purple: 'outline-purple-500/25',
  fuchsia: 'outline-fuchsia-500/25',
  pink: 'outline-pink-500/25',
  rose: 'outline-rose-500/25',
  default: '',
  // warmGray: 'outline-warmGray-500/25',
  // trueGray: 'outline-trueGray-500/25',
  // coolGray: 'outline-coolGray-500/25',
  // blueGray: 'outline-blueGray-500/25',
}

export const darkBgColor300p25: Record<ColorKey, string> = {
  black: 'dark:bg-black/25',
  white: 'dark:bg-white/25',
  slate: 'dark:bg-slate-300/25',
  gray: 'dark:bg-gray-300/25',
  zinc: 'dark:bg-zinc-300/25',
  neutral: 'dark:bg-neutral-300/25',
  stone: 'dark:bg-stone-300/25',
  red: 'dark:bg-red-300/25',
  orange: 'dark:bg-orange-300/25',
  amber: 'dark:bg-amber-300/25',
  yellow: 'dark:bg-yellow-300/25',
  lime: 'dark:bg-lime-300/25',
  green: 'dark:bg-green-300/25',
  emerald: 'dark:bg-emerald-300/25',
  teal: 'dark:bg-teal-300/25',
  cyan: 'dark:bg-cyan-300/25',
  sky: 'dark:bg-sky-300/25',
  blue: 'dark:bg-blue-300/25',
  indigo: 'dark:bg-indigo-300/25',
  violet: 'dark:bg-violet-300/25',
  purple: 'dark:bg-purple-300/25',
  fuchsia: 'dark:bg-fuchsia-300/25',
  pink: 'dark:bg-pink-300/25',
  rose: 'dark:bg-rose-300/25',
  default: 'dark:bg-default-300/25',
  // warmGray: 'dark:bg-warmGray-300/25',
  // trueGray: 'dark:bg-trueGray-300/25',
  // coolGray: 'dark:bg-coolGray-300/25',
  // blueGray: 'dark:bg-blueGray-300/25',
}
export const darkBgColor500p25: Record<ColorKey, string> = {
  black: 'dark:bg-black/25',
  white: 'dark:bg-white/25',
  slate: 'dark:bg-slate-500/25',
  gray: 'dark:bg-gray-500/25',
  zinc: 'dark:bg-zinc-500/25',
  neutral: 'dark:bg-neutral-500/25',
  stone: 'dark:bg-stone-500/25',
  red: 'dark:bg-red-500/25',
  orange: 'dark:bg-orange-500/25',
  amber: 'dark:bg-amber-500/25',
  yellow: 'dark:bg-yellow-500/25',
  lime: 'dark:bg-lime-500/25',
  green: 'dark:bg-green-500/25',
  emerald: 'dark:bg-emerald-500/25',
  teal: 'dark:bg-teal-500/25',
  cyan: 'dark:bg-cyan-500/25',
  sky: 'dark:bg-sky-500/25',
  blue: 'dark:bg-blue-500/25',
  indigo: 'dark:bg-indigo-500/25',
  violet: 'dark:bg-violet-500/25',
  purple: 'dark:bg-purple-500/25',
  fuchsia: 'dark:bg-fuchsia-500/25',
  pink: 'dark:bg-pink-500/25',
  rose: 'dark:bg-rose-500/25',
  default: 'dark:bg-default-500/25',
  // warmGray: 'dark:bg-warmGray-500/25',
  // trueGray: 'dark:bg-trueGray-500/25',
  // coolGray: 'dark:bg-coolGray-500/25',
  // blueGray: 'dark:bg-blueGray-500/25',
}

export const darkBorderColor300: Record<ColorKey, string> = {
  black: 'dark:border-black',
  white: 'dark:border-white',
  slate: 'dark:border-slate-300',
  gray: 'dark:border-gray-300',
  zinc: 'dark:border-zinc-300',
  neutral: 'dark:border-neutral-300',
  stone: 'dark:border-stone-300',
  red: 'dark:border-red-300',
  orange: 'dark:border-orange-300',
  amber: 'dark:border-amber-300',
  yellow: 'dark:border-yellow-300',
  lime: 'dark:border-lime-300',
  green: 'dark:border-green-300',
  emerald: 'dark:border-emerald-300',
  teal: 'dark:border-teal-300',
  cyan: 'dark:border-cyan-300',
  sky: 'dark:border-sky-300',
  blue: 'dark:border-blue-300',
  indigo: 'dark:border-indigo-300',
  violet: 'dark:border-violet-300',
  purple: 'dark:border-purple-300',
  fuchsia: 'dark:border-fuchsia-300',
  pink: 'dark:border-pink-300',
  rose: 'dark:border-rose-300',
  default: 'dark:border-default-300',
  // warmGray: 'dark:border-warmGray-300',
  // trueGray: 'dark:border-trueGray-300',
  // coolGray: 'dark:border-coolGray-300',
  // blueGray: 'dark:border-blueGray-300',
}
export const darkBorderColor500: Record<ColorKey, string> = {
  black: 'dark:border-black',
  white: 'dark:border-white',
  slate: 'dark:border-slate-500',
  gray: 'dark:border-gray-500',
  zinc: 'dark:border-zinc-500',
  neutral: 'dark:border-neutral-500',
  stone: 'dark:border-stone-500',
  red: 'dark:border-red-500',
  orange: 'dark:border-orange-500',
  amber: 'dark:border-amber-500',
  yellow: 'dark:border-yellow-500',
  lime: 'dark:border-lime-500',
  green: 'dark:border-green-500',
  emerald: 'dark:border-emerald-500',
  teal: 'dark:border-teal-500',
  cyan: 'dark:border-cyan-500',
  sky: 'dark:border-sky-500',
  blue: 'dark:border-blue-500',
  indigo: 'dark:border-indigo-500',
  violet: 'dark:border-violet-500',
  purple: 'dark:border-purple-500',
  fuchsia: 'dark:border-fuchsia-500',
  pink: 'dark:border-pink-500',
  rose: 'dark:border-rose-500',
  default: 'dark:border-default-500',
  // warmGray: 'dark:border-warmGray-500',
  // trueGray: 'dark:border-trueGray-500',
  // coolGray: 'dark:border-coolGray-500',
  // blueGray: 'dark:border-blueGray-500',
}

export const darkTextColor300: Record<ColorKey, string> = {
  black: 'dark:text-black',
  white: 'dark:text-white',
  slate: 'dark:text-slate-300',
  gray: 'dark:text-gray-300',
  zinc: 'dark:text-zinc-300',
  neutral: 'dark:text-neutral-300',
  stone: 'dark:text-stone-300',
  red: 'dark:text-red-300',
  orange: 'dark:text-orange-300',
  amber: 'dark:text-amber-300',
  yellow: 'dark:text-yellow-300',
  lime: 'dark:text-lime-300',
  green: 'dark:text-green-300',
  emerald: 'dark:text-emerald-300',
  teal: 'dark:text-teal-300',
  cyan: 'dark:text-cyan-300',
  sky: 'dark:text-sky-300',
  blue: 'dark:text-blue-300',
  indigo: 'dark:text-indigo-300',
  violet: 'dark:text-violet-300',
  purple: 'dark:text-purple-300',
  fuchsia: 'dark:text-fuchsia-300',
  pink: 'dark:text-pink-300',
  rose: 'dark:text-rose-300',
  default: 'dark:text-default-300',
  // warmGray: 'dark:text-warmGray-300',
  // trueGray: 'dark:text-trueGray-300',
  // coolGray: 'dark:text-coolGray-300',
  // blueGray: 'dark:text-blueGray-300',
}
export const darkTextColor500: Record<ColorKey, string> = {
  black: 'dark:text-black',
  white: 'dark:text-white',
  slate: 'dark:text-slate-500',
  gray: 'dark:text-gray-500',
  zinc: 'dark:text-zinc-500',
  neutral: 'dark:text-neutral-500',
  stone: 'dark:text-stone-500',
  red: 'dark:text-red-500',
  orange: 'dark:text-orange-500',
  amber: 'dark:text-amber-500',
  yellow: 'dark:text-yellow-500',
  lime: 'dark:text-lime-500',
  green: 'dark:text-green-500',
  emerald: 'dark:text-emerald-500',
  teal: 'dark:text-teal-500',
  cyan: 'dark:text-cyan-500',
  sky: 'dark:text-sky-500',
  blue: 'dark:text-blue-500',
  indigo: 'dark:text-indigo-500',
  violet: 'dark:text-violet-500',
  purple: 'dark:text-purple-500',
  fuchsia: 'dark:text-fuchsia-500',
  pink: 'dark:text-pink-500',
  rose: 'dark:text-rose-500',
  default: 'dark:text-default-500',
  // warmGray: 'dark:text-warmGray-500',
  // trueGray: 'dark:text-trueGray-500',
  // coolGray: 'dark:text-coolGray-500',
  // blueGray: 'dark:text-blueGray-500',
}

export const hoverBgColor500p25: Record<ColorKey, string> = {
  black: 'hover:bg-black/25',
  white: 'hover:bg-white/25',
  slate: 'hover:bg-slate-500/25',
  gray: 'hover:bg-gray-500/25',
  zinc: 'hover:bg-zinc-500/25',
  neutral: 'hover:bg-neutral-500/25',
  stone: 'hover:bg-stone-500/25',
  red: 'hover:bg-red-500/25',
  orange: 'hover:bg-orange-500/25',
  amber: 'hover:bg-amber-500/25',
  yellow: 'hover:bg-yellow-500/25',
  lime: 'hover:bg-lime-500/25',
  green: 'hover:bg-green-500/25',
  emerald: 'hover:bg-emerald-500/25',
  teal: 'hover:bg-teal-500/25',
  cyan: 'hover:bg-cyan-500/25',
  sky: 'hover:bg-sky-500/25',
  blue: 'hover:bg-blue-500/25',
  indigo: 'hover:bg-indigo-500/25',
  violet: 'hover:bg-violet-500/25',
  purple: 'hover:bg-purple-500/25',
  fuchsia: 'hover:bg-fuchsia-500/25',
  pink: 'hover:bg-pink-500/25',
  rose: 'hover:bg-rose-500/25',
  default: 'hover:bg-default-500/25',
  // warmGray: 'hover:bg-warmGray-500/25',
  // trueGray: 'hover:bg-trueGray-500/25',
  // coolGray: 'hover:bg-coolGray-500/25',
  // blueGray: 'hover:bg-blueGray-500/25',
}
export const hoverTextColor500: Record<ColorKey, string> = {
  black: 'hover:text-black',
  white: 'hover:text-white',
  slate: 'hover:text-slate-500',
  gray: 'hover:text-gray-500',
  zinc: 'hover:text-zinc-500',
  neutral: 'hover:text-neutral-500',
  stone: 'hover:text-stone-500',
  red: 'hover:text-red-500',
  orange: 'hover:text-orange-500',
  amber: 'hover:text-amber-500',
  yellow: 'hover:text-yellow-500',
  lime: 'hover:text-lime-500',
  green: 'hover:text-green-500',
  emerald: 'hover:text-emerald-500',
  teal: 'hover:text-teal-500',
  cyan: 'hover:text-cyan-500',
  sky: 'hover:text-sky-500',
  blue: 'hover:text-blue-500',
  indigo: 'hover:text-indigo-500',
  violet: 'hover:text-violet-500',
  purple: 'hover:text-purple-500',
  fuchsia: 'hover:text-fuchsia-500',
  pink: 'hover:text-pink-500',
  rose: 'hover:text-rose-500',
  default: '',
  // warmGray: 'hover:text-warmGray-500',
  // trueGray: 'hover:text-trueGray-500',
  // coolGray: 'hover:text-coolGray-500',
  // blueGray: 'hover:text-blueGray-500',
}

export const focusRingColor500p25: Record<ColorKey, string> = {
  black: 'focus:ring-black/25',
  white: 'focus:ring-white/25',
  slate: 'focus:ring-slate-500/25',
  gray: 'focus:ring-gray-500/25',
  zinc: 'focus:ring-zinc-500/25',
  neutral: 'focus:ring-neutral-500/25',
  stone: 'focus:ring-stone-500/25',
  red: 'focus:ring-red-500/25',
  orange: 'focus:ring-orange-500/25',
  amber: 'focus:ring-amber-500/25',
  yellow: 'focus:ring-yellow-500/25',
  lime: 'focus:ring-lime-500/25',
  green: 'focus:ring-green-500/25',
  emerald: 'focus:ring-emerald-500/25',
  teal: 'focus:ring-teal-500/25',
  cyan: 'focus:ring-cyan-500/25',
  sky: 'focus:ring-sky-500/25',
  blue: 'focus:ring-blue-500/25',
  indigo: 'focus:ring-indigo-500/25',
  violet: 'focus:ring-violet-500/25',
  purple: 'focus:ring-purple-500/25',
  fuchsia: 'focus:ring-fuchsia-500/25',
  pink: 'focus:ring-pink-500/25',
  rose: 'focus:ring-rose-500/25',
  default: '',
  // warmGray: 'focus:ring-warmGray-500/25',
  // trueGray: 'focus:ring-trueGray-500/25',
  // coolGray: 'focus:ring-coolGray-500/25',
  // blueGray: 'focus:ring-blueGray-500/25',
}

export const heightSize = {
  '0': 'h-0',
  '1': 'h-1',
  '2': 'h-2',
  '3': 'h-3',
  '4': 'h-4',
  '5': 'h-5',
  '6': 'h-6',
  '7': 'h-7',
  '8': 'h-8',
  '9': 'h-9',
  '10': 'h-10',
  '11': 'h-11',
  '12': 'h-12',
  '14': 'h-14',
  '16': 'h-16',
  '20': 'h-20',
  '24': 'h-24',
  '28': 'h-28',
  '29': 'h-29',
  '32': 'h-32',
  '36': 'h-36',
  '40': 'h-40',
  '44': 'h-44',
  '48': 'h-48',
  '52': 'h-52',
  '56': 'h-56',
  '60': 'h-60',
  '64': 'h-64',
  '72': 'h-72',
  '80': 'h-80',
  '96': 'h-96',
  '100': 'h-100',
  '128': 'h-128',
  auto: 'h-auto',
  px: 'h-px',
  '0.5': 'h-0.5',
  '1.5': 'h-1.5',
  '2.5': 'h-2.5',
  '3.5': 'h-3.5',
  '1/2': 'h-1/2',
  '1/3': 'h-1/3',
  '2/3': 'h-2/3',
  '1/4': 'h-1/4',
  '3/4': 'h-3/4',
  '1/5': 'h-1/5',
  '2/5': 'h-2/5',
  '3/5': 'h-3/5',
  '4/5': 'h-4/5',
  '1/6': 'h-1/6',
  '5/6': 'h-5/6',
  '1/12': 'h-1/12',
  full: 'h-full',
  screen: 'h-screen',
  min: 'h-min',
  max: 'h-max',
  fit: 'h-fit',
}
export const widthSize: Record<SizeKey, string> = {
  '0': 'w-0',
  '1': 'w-1',
  '2': 'w-2',
  '3': 'w-3',
  '4': 'w-4',
  '5': 'w-5',
  '6': 'w-6',
  '7': 'w-7',
  '8': 'w-8',
  '9': 'w-9',
  '10': 'w-10',
  '11': 'w-11',
  '12': 'w-12',
  '14': 'w-14',
  '16': 'w-16',
  '20': 'w-20',
  '24': 'w-24',
  '28': 'w-28',
  '29': 'w-29',
  '32': 'w-32',
  '36': 'w-36',
  '40': 'w-40',
  '44': 'w-44',
  '48': 'w-48',
  '52': 'w-52',
  '56': 'w-56',
  '60': 'w-60',
  '64': 'w-64',
  '72': 'w-72',
  '80': 'w-80',
  '96': 'w-96',
  '100': 'w-100',
  '128': 'w-128',
  auto: 'w-auto',
  px: 'w-px',
  '0.5': 'w-0.5',
  '1.5': 'w-1.5',
  '2.5': 'w-2.5',
  '3.5': 'w-3.5',
  '1/2': 'w-1/2',
  '1/3': 'w-1/3',
  '2/3': 'w-2/3',
  '1/4': 'w-1/4',
  '3/4': 'w-3/4',
  '1/5': 'w-1/5',
  '2/5': 'w-2/5',
  '3/5': 'w-3/5',
  '4/5': 'w-4/5',
  '1/6': 'w-1/6',
  '5/6': 'w-5/6',
  '1/12': 'w-1/12',
  full: 'w-full',
  screen: 'w-screen',
  min: 'w-min',
  max: 'w-max',
  fit: 'w-fit',
}

export const roundedClass = {
  none: 'rounded-none',
  sm: 'rounded-xs',
  md: 'rounded-md',
  lg: 'rounded-lg',
  xl: 'rounded-xl',
  '2xl': 'rounded-2xl',
  '3xl': 'rounded-3xl',
  full: 'rounded-full',
}

export const textColor500: Record<ColorKey, string> = {
  black: 'text-black',
  white: 'text-white',
  slate: 'text-slate-500',
  gray: 'text-gray-500',
  zinc: 'text-zinc-500',
  neutral: 'text-neutral-500',
  stone: 'text-stone-500',
  red: 'text-red-500',
  orange: 'text-orange-500',
  amber: 'text-amber-500',
  yellow: 'text-yellow-500',
  lime: 'text-lime-500',
  green: 'text-green-500',
  emerald: 'text-emerald-500',
  teal: 'text-teal-500',
  cyan: 'text-cyan-500',
  sky: 'text-sky-500',
  blue: 'text-blue-500',
  indigo: 'text-indigo-500',
  violet: 'text-violet-500',
  purple: 'text-purple-500',
  fuchsia: 'text-fuchsia-500',
  pink: 'text-pink-500',
  rose: 'text-rose-500',
  default: '',
  // warmGray: 'text-warmGray-500',
  // trueGray: 'text-trueGray-500',
  // coolGray: 'text-coolGray-500',
  // blueGray: 'text-blueGray-500',
}
export const textColor600: Record<ColorKey, string> = {
  black: 'text-black',
  white: 'text-white',
  slate: 'text-slate-600',
  gray: 'text-gray-600',
  zinc: 'text-zinc-600',
  neutral: 'text-neutral-600',
  stone: 'text-stone-600',
  red: 'text-red-600',
  orange: 'text-orange-600',
  amber: 'text-amber-600',
  yellow: 'text-yellow-600',
  lime: 'text-lime-600',
  green: 'text-green-600',
  emerald: 'text-emerald-600',
  teal: 'text-teal-600',
  cyan: 'text-cyan-600',
  sky: 'text-sky-600',
  blue: 'text-blue-600',
  indigo: 'text-indigo-600',
  violet: 'text-violet-600',
  purple: 'text-purple-600',
  fuchsia: 'text-fuchsia-600',
  pink: 'text-pink-600',
  rose: 'text-rose-600',
  default: '', // hanya ikut di deklarasikan saja sebagai key
  // warmGray: 'text-warmGray-600',
  // trueGray: 'text-trueGray-600',
  // coolGray: 'text-coolGray-600',
  // blueGray: 'text-blueGray-600',
}

export const textSize = {
  xs: 'text-xs',
  sm: 'text-sm',
  base: 'text-base',
  lg: 'text-lg',
  xl: 'text-xl',
  '2xl': 'text-2xl',
  '3xl': 'text-3xl',
  '4xl': 'text-4xl',
  '5xl': 'text-5xl',
  '6xl': 'text-6xl',
  '7xl': 'text-7xl',
  '8xl': 'text-8xl',
  '9xl': 'text-9xl',
}

export const maxWidthSize = {
  // '3xs': 'max-w-3xs',
  // '2xs': 'max-w-2xs',
  // xs: 'max-w-xs',
  // sm: 'max-w-sm',
  // md: 'max-w-md',
  // lg: 'max-w-lg',
  // xl: 'max-w-xl',
  // '2xl': 'max-w-2xl',
  // '3xl': 'max-w-3xl',
  '4xl': 'max-w-4xl',
  // '5xl': 'max-w-5xl',
  // '6xl': 'max-w-6xl',
  '7xl': 'max-w-7xl',
  // none: 'max-w-none',
}
